import React from 'react';
import { Card } from 'react-bootstrap';
import { PdfLoader } from './PdfLoader';
import { FinalReportLoader } from './FinalReportLoader';
import { Pie } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

interface Props {
  data: any;
}

export const DefaultProgressByOwner = (props: Props) => {
  const { user } = useSelector((state: any) => ({ user: state.user }));

  // const source = data.physicalOwnerView.source==="Capital"?;

  return props.data.physicalOwnerView
    .filter((owner) => owner.Source === user.currentRole.source)
    .map((owner, index) => (
      <Card style={{ width: '100%' }} className='mr-2 mb-2' key={index}>
        <Card.Header style={{ backgroundColor: owner.Source === 'Capital' ? '#eef' : '' }}>
          <b>{owner.Source}</b> Physical Owner #{owner.PhysicalOwner}
          <Card.Subtitle className='mt-2 mb-2'>Property Coordinator: {owner.PropertyCoordinator}</Card.Subtitle>
          <span>{user.currentRole.isAdmin && <PdfLoader owner={owner} />}</span>
          <span className='float-right'>{user.currentRole.isAdmin && <FinalReportLoader owner={owner} />}</span>
        </Card.Header>
        <Card.Body>
          <Card.Subtitle className='text-muted'>
            Total Items: {owner.TotalItems}
            <span className='float-right'>{owner.PercentComplete.toFixed(0)}% Complete</span>
          </Card.Subtitle>
          <Pie
            data={{
              labels: ['Unscanned Items', 'Scanned Items'],
              datasets: [
                {
                  label: 'Scanned',
                  data: [owner.TotalItems - owner.ItemsVerified, owner.ItemsVerified],
                  backgroundColor: ['#F39C12', '#00bc8c'],
                },
              ],
            }}
            options={{
              maintainAspectRatio: true,
              responsive: true,
              legend: { display: false },
            }}
          />
        </Card.Body>
      </Card>
    ));
};
